import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const I18nContext = createContext({ lang: "en", t: (k) => k, setLang: () => {}, languages: [] });

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("icos_lang") || "en");
  const [pack, setPack] = useState({});
  const [languages, setLanguages] = useState([]);

  useEffect(() => {
    api.get("/i18n").then(r => setLanguages(r.data.languages)).catch(()=>{});
  }, []);

  useEffect(() => {
    api.get(`/i18n/${lang}`).then(r => setPack(r.data.strings || {})).catch(()=>{});
    localStorage.setItem("icos_lang", lang);
  }, [lang]);

  const t = (key) => pack[key] || key;
  return <I18nContext.Provider value={{ lang, setLang, t, languages }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
